// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Coach add-session dialogs — shared shell (type picker, spontaneous, seasonal) */

.asd-dialog.MuiPaper-root,
.asd-dialog {
  border-radius: 20px !important;
  overflow: hidden;
  display: flex !important;
  flex-direction: column;
  max-height: calc(
    100dvh - 24px - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px)
  ) !important;
  margin: 12px !important;
  background: var(--surface-color, #111827) !important;
  color: var(--text-color, #f9fafb) !important;
  color-scheme: light;
  box-shadow: 0 24px 60px var(--shadow-color, rgba(0, 0, 0, 0.35)) !important;
  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.22)) !important;
}

.asd-modal-box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: min(480px, calc(100vw - 24px));
  max-height: calc(
    100dvh - 24px - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px)
  );
  display: flex;
  flex-direction: column;
  overflow: hidden;
  outline: none;
  border-radius: 20px;
  background: var(--surface-color, #111827);
  color: var(--text-color, #f9fafb);
  color-scheme: light;
  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.22));
  box-shadow: 0 24px 60px var(--shadow-color, rgba(0, 0, 0, 0.35));
}

.asd-modal-box--wide {
  width: min(560px, calc(100vw - 24px));
}

.asd {
  display: flex;
  flex-direction: column;
  min-height: 0;
  max-height: inherit;
  height: 100%;
}

.asd__header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 20px 18px 14px;
  flex-shrink: 0;
  background:
    radial-gradient(
      120% 80% at 0% 0%,
      color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent) 0%,
      transparent 55%
    ),
    var(--surface-color, #111827);
  border-bottom: 1px solid var(--border-color, rgba(148, 163, 184, 0.18));
}

.asd__hero {
  width: 44px;
  height: 44px;
  border-radius: 14px;
  display: grid;
  place-items: center;
  flex-shrink: 0;
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 18%, transparent);
  color: var(--brand-primary, #0877bc);
}

.asd__header-text {
  flex: 1 1;
  min-width: 0;
}

.asd__eyebrow {
  margin: 0 0 2px;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--brand-primary, #0877bc);
}

.asd__title {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1.25;
  letter-spacing: -0.02em;
  color: var(--text-color);
}

.asd__hint {
  margin: 6px 0 0;
  font-size: 0.88rem;
  line-height: 1.4;
  color: var(--text-secondary, #9ca3af);
}

.asd__close {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: var(--text-secondary, #9ca3af);
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: background 0.2s ease, color 0.2s ease;
}

.asd__close:hover {
  color: var(--text-color);
  background: color-mix(in srgb, var(--text-color) 8%, transparent);
}

.asd__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 16px 18px 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.asd__section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.asd__label {
  margin: 0;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--text-secondary, #9ca3af);
}

.asd__field-shell {
  padding: 12px;
  border-radius: 16px;
  background: color-mix(in srgb, var(--text-color) 4%, var(--surface-color));
  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.22));
}

.asd__calendar {
  display: flex;
  justify-content: center;
  overflow: hidden;
  border-radius: 12px;
}

.asd__calendar .rdrCalendarWrapper,
.asd__calendar .rdrDateDisplayWrapper,
.asd__calendar .rdrMonth {
  background: transparent !important;
  color: var(--text-color) !important;
}

.asd__calendar .rdrMonthAndYearPickers select,
.asd__calendar .rdrWeekDay,
.asd__calendar .rdrDayNumber span {
  color: var(--text-color) !important;
}

.asd__calendar .rdrDayPassive .rdrDayNumber span {
  color: var(--text-secondary) !important;
  opacity: 0.55;
}

.asd__calendar .rdrDayDisabled {
  background-color: transparent !important;
}

.asd__calendar .rdrDayToday .rdrDayNumber span:after {
  background: var(--brand-primary, #0877bc) !important;
}

.asd__calendar .rdrSelected,
.asd__calendar .rdrDayStartPreview,
.asd__calendar .rdrDayEndPreview,
.asd__calendar .rdrDayInPreview {
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent) !important;
}

.asd__calendar .rdrNextPrevButton {
  background: color-mix(in srgb, var(--text-color) 8%, var(--surface-color)) !important;
}

.asd__calendar .rdrNextPrevButton i,
.asd__calendar .rdrPprevButton i {
  border-color: var(--text-color) !important;
}

.asd__input,
.asd__select {
  width: 100%;
  box-sizing: border-box;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.28));
  background: var(--surface-color);
  color: var(--text-color);
  color-scheme: light;
  font: inherit;
  font-size: 0.95rem;
  font-weight: 600;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

html[data-theme="dark"] .asd-dialog.MuiPaper-root,
html.dark-mode .asd-dialog.MuiPaper-root,
.dark-mode .asd-dialog.MuiPaper-root,
html[data-theme="dark"] .asd-modal-box,
html.dark-mode .asd-modal-box,
.dark-mode .asd-modal-box,
html[data-theme="dark"] .asd__input,
html.dark-mode .asd__input,
.dark-mode .asd__input,
html[data-theme="dark"] .asd__select,
html.dark-mode .asd__select,
.dark-mode .asd__select {
  color-scheme: dark;
}

.asd__label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.asd__label-row .asd__label {
  margin: 0;
}

.asd__chip--now {
  padding: 4px 10px;
  font-size: 0.72rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.asd__time-controls {
  display: flex;
  align-items: stretch;
  gap: 8px;
}

.asd__time-controls .asd__input {
  flex: 1 1;
  min-width: 0;
}

.asd__input--time::-webkit-calendar-picker-indicator {
  opacity: 0;
  width: 0;
  padding: 0;
  margin: 0;
  pointer-events: none;
}

.asd__clock-btn {
  appearance: none;
  flex-shrink: 0;
  width: 46px;
  border-radius: 12px;
  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.28));
  background: var(--surface-color);
  color: var(--text-color);
  display: grid;
  place-items: center;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: border-color 0.2s ease, color 0.2s ease, background 0.2s ease;
}

.asd__clock-btn:hover,
.asd__clock-btn:focus-visible {
  outline: none;
  color: var(--brand-primary, #0877bc);
  border-color: var(--brand-primary, #0877bc);
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 10%, var(--surface-color));
}

.asd__input:focus,
.asd__select:focus {
  outline: none;
  border-color: var(--brand-primary, #0877bc);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent);
}

.asd__row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

@media (max-width: 420px) {
  .asd__row {
    grid-template-columns: 1fr;
  }
}

.asd__duration-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.asd__chip {
  appearance: none;
  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.28));
  background: var(--surface-color);
  color: var(--text-color);
  border-radius: 999px;
  padding: 8px 14px;
  font: inherit;
  font-size: 0.82rem;
  font-weight: 650;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease,
    transform 0.2s cubic-bezier(0.25, 1, 0.5, 1);
}

.asd__chip:hover {
  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 45%, var(--border-color));
  transform: translateY(-1px);
}

.asd__chip.is-active {
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 16%, var(--surface-color));
  border-color: var(--brand-primary, #0877bc);
  color: var(--brand-primary, #0877bc);
}

.asd__day-grid {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 6px;
}

.asd__day {
  appearance: none;
  aspect-ratio: 1;
  min-height: 40px;
  border-radius: 12px;
  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.28));
  background: var(--surface-color);
  color: var(--text-secondary, #9ca3af);
  font: inherit;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease,
    transform 0.2s cubic-bezier(0.25, 1, 0.5, 1);
}

.asd__day:hover {
  transform: translateY(-1px);
  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 45%, var(--border-color));
}

.asd__day.is-active {
  background: var(--brand-primary, #0877bc);
  border-color: var(--brand-primary, #0877bc);
  color: #fff;
  box-shadow: 0 6px 16px color-mix(in srgb, var(--brand-primary, #0877bc) 35%, transparent);
}

.asd__type-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.asd__type-card {
  appearance: none;
  width: 100%;
  text-align: left;
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 14px 16px;
  border-radius: 16px;
  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.28));
  background: color-mix(in srgb, var(--text-color) 3%, var(--surface-color));
  color: var(--text-color);
  cursor: pointer;
  transition: border-color 0.2s ease, background 0.2s ease, transform 0.2s cubic-bezier(0.25, 1, 0.5, 1),
    box-shadow 0.2s ease;
}

.asd__type-card:hover:not(:disabled) {
  transform: translateY(-2px);
  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 45%, var(--border-color));
  box-shadow: 0 10px 24px color-mix(in srgb, var(--brand-primary, #0877bc) 14%, transparent);
}

.asd__type-card:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.asd__type-card.is-active {
  border-color: var(--brand-primary, #0877bc);
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 12%, var(--surface-color));
  box-shadow: 0 0 0 1px color-mix(in srgb, var(--brand-primary, #0877bc) 35%, transparent);
}

.asd__type-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  flex-shrink: 0;
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 16%, transparent);
  color: var(--brand-primary, #0877bc);
}

.asd__type-card.is-active .asd__type-icon {
  background: var(--brand-primary, #0877bc);
  color: #fff;
}

.asd__type-copy {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.asd__type-title {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.asd__type-desc {
  margin: 0;
  font-size: 0.84rem;
  line-height: 1.4;
  color: var(--text-secondary, #9ca3af);
}

.asd__type-chevron {
  align-self: center;
  color: var(--text-secondary, #9ca3af);
  opacity: 0.7;
  flex-shrink: 0;
}

.asd__alert {
  margin: 0;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid color-mix(in srgb, #d97706 35%, transparent);
  background: color-mix(in srgb, #d97706 12%, var(--surface-color));
  color: #b45309;
  font-size: 0.88rem;
  line-height: 1.4;
}

.dark-mode .asd__alert,
html.dark-mode .asd__alert {
  color: #fbbf24;
}

.asd__actions {
  flex-shrink: 0;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  padding: 12px 18px max(16px, calc(12px + env(safe-area-inset-bottom, 0px)));
  border-top: 1px solid var(--border-color, rgba(148, 163, 184, 0.18));
  background: inherit;
}

.asd__btn {
  appearance: none;
  font: inherit;
  border: 0;
  border-radius: 12px;
  padding: 11px 16px;
  cursor: pointer;
  font-weight: 650;
  transition: transform 0.2s cubic-bezier(0.25, 1, 0.5, 1), filter 0.2s ease,
    background 0.2s ease;
}

.asd__btn:not(:disabled):hover {
  transform: scale(1.01);
}

.asd__btn:not(:disabled):active {
  transform: scale(0.98);
}

.asd__btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.asd__btn--ghost {
  background: transparent;
  color: var(--text-secondary, #9ca3af);
  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.28));
}

.asd__btn--ghost:hover:not(:disabled) {
  color: var(--text-color);
  background: color-mix(in srgb, var(--text-color) 6%, transparent);
}

.asd__btn--primary {
  background: var(--brand-primary, #0877bc);
  color: #fff;
  box-shadow: 0 8px 20px color-mix(in srgb, var(--brand-primary, #0877bc) 32%, transparent);
}

.asd__btn--primary:hover:not(:disabled) {
  filter: brightness(1.06);
}

.asd__btn--block {
  width: 100%;
}

@media (prefers-reduced-motion: reduce) {
  .asd__chip,
  .asd__day,
  .asd__type-card,
  .asd__btn {
    transition: none;
  }

  .asd__chip:hover,
  .asd__day:hover,
  .asd__type-card:hover:not(:disabled),
  .asd__btn:not(:disabled):hover,
  .asd__btn:not(:disabled):active {
    transform: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AddSessionDialog.css"],"names":[],"mappings":"AAAA,kFAAkF;;AAElF;;EAEE,8BAA8B;EAC9B,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;EACtB;;cAEY;EACZ,uBAAuB;EACvB,oDAAoD;EACpD,4CAA4C;EAC5C,mBAAmB;EACnB,2EAA2E;EAC3E,2EAA2E;AAC7E;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,qCAAqC;EACrC;;GAEC;EACD,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,iCAAiC;EACjC,mBAAmB;EACnB,gEAAgE;EAChE,gEAAgE;AAClE;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd;;;;;;iCAM+B;EAC/B,uEAAuE;AACzE;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,8EAA8E;EAC9E,oCAAoC;AACtC;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;EACf,wCAAwC;EACxC,iDAAiD;AACnD;;AAEA;EACE,wBAAwB;EACxB,iEAAiE;AACnE;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,iCAAiC;EACjC,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0EAA0E;EAC1E,gEAAgE;AAClE;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;EAGE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;;;EAGE,mCAAmC;AACrC;;AAEA;EACE,uCAAuC;EACvC,aAAa;AACf;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;;;;EAIE,yFAAyF;AAC3F;;AAEA;EACE,qFAAqF;AACvF;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;;EAEE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,gEAAgE;EAChE,gCAAgC;EAChC,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,wDAAwD;AAC1D;;AAEA;;;;;;;;;;;;EAYE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,UAAU;EACV,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,gEAAgE;EAChE,gCAAgC;EAChC,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,wCAAwC;EACxC,yEAAyE;AAC3E;;AAEA;;EAEE,aAAa;EACb,oCAAoC;EACpC,2CAA2C;EAC3C,uFAAuF;AACzF;;AAEA;;EAEE,aAAa;EACb,2CAA2C;EAC3C,wFAAwF;AAC1F;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,gEAAgE;EAChE,gCAAgC;EAChC,wBAAwB;EACxB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf;gDAC8C;AAChD;;AAEA;EACE,wFAAwF;EACxF,2BAA2B;AAC7B;;AAEA;EACE,uFAAuF;EACvF,2CAA2C;EAC3C,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gEAAgE;EAChE,gCAAgC;EAChC,qCAAqC;EACrC,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf;gDAC8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,wFAAwF;AAC1F;;AAEA;EACE,yCAAyC;EACzC,2CAA2C;EAC3C,WAAW;EACX,yFAAyF;AAC3F;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gEAAgE;EAChE,0EAA0E;EAC1E,wBAAwB;EACxB,eAAe;EACf;wBACsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,wFAAwF;EACxF,0FAA0F;AAC5F;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,uFAAuF;EACvF,wFAAwF;AAC1F;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,8EAA8E;EAC9E,oCAAoC;AACtC;;AAEA;EACE,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,8DAA8D;EAC9D,iEAAiE;EACjE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,2EAA2E;EAC3E,oEAAoE;EACpE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB;wBACsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,gEAAgE;AAClE;;AAEA;EACE,wBAAwB;EACxB,iEAAiE;AACnE;;AAEA;EACE,yCAAyC;EACzC,WAAW;EACX,yFAAyF;AAC3F;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;;;;IAIE,gBAAgB;EAClB;;EAEA;;;;;IAKE,eAAe;EACjB;AACF","sourcesContent":["/* Coach add-session dialogs — shared shell (type picker, spontaneous, seasonal) */\n\n.asd-dialog.MuiPaper-root,\n.asd-dialog {\n  border-radius: 20px !important;\n  overflow: hidden;\n  display: flex !important;\n  flex-direction: column;\n  max-height: calc(\n    100dvh - 24px - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px)\n  ) !important;\n  margin: 12px !important;\n  background: var(--surface-color, #111827) !important;\n  color: var(--text-color, #f9fafb) !important;\n  color-scheme: light;\n  box-shadow: 0 24px 60px var(--shadow-color, rgba(0, 0, 0, 0.35)) !important;\n  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.22)) !important;\n}\n\n.asd-modal-box {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: min(480px, calc(100vw - 24px));\n  max-height: calc(\n    100dvh - 24px - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px)\n  );\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  outline: none;\n  border-radius: 20px;\n  background: var(--surface-color, #111827);\n  color: var(--text-color, #f9fafb);\n  color-scheme: light;\n  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.22));\n  box-shadow: 0 24px 60px var(--shadow-color, rgba(0, 0, 0, 0.35));\n}\n\n.asd-modal-box--wide {\n  width: min(560px, calc(100vw - 24px));\n}\n\n.asd {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  max-height: inherit;\n  height: 100%;\n}\n\n.asd__header {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 20px 18px 14px;\n  flex-shrink: 0;\n  background:\n    radial-gradient(\n      120% 80% at 0% 0%,\n      color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent) 0%,\n      transparent 55%\n    ),\n    var(--surface-color, #111827);\n  border-bottom: 1px solid var(--border-color, rgba(148, 163, 184, 0.18));\n}\n\n.asd__hero {\n  width: 44px;\n  height: 44px;\n  border-radius: 14px;\n  display: grid;\n  place-items: center;\n  flex-shrink: 0;\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 18%, transparent);\n  color: var(--brand-primary, #0877bc);\n}\n\n.asd__header-text {\n  flex: 1;\n  min-width: 0;\n}\n\n.asd__eyebrow {\n  margin: 0 0 2px;\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--brand-primary, #0877bc);\n}\n\n.asd__title {\n  margin: 0;\n  font-size: 1.2rem;\n  font-weight: 700;\n  line-height: 1.25;\n  letter-spacing: -0.02em;\n  color: var(--text-color);\n}\n\n.asd__hint {\n  margin: 6px 0 0;\n  font-size: 0.88rem;\n  line-height: 1.4;\n  color: var(--text-secondary, #9ca3af);\n}\n\n.asd__close {\n  flex-shrink: 0;\n  width: 36px;\n  height: 36px;\n  display: grid;\n  place-items: center;\n  border: 0;\n  border-radius: 10px;\n  background: transparent;\n  color: var(--text-secondary, #9ca3af);\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n  transition: background 0.2s ease, color 0.2s ease;\n}\n\n.asd__close:hover {\n  color: var(--text-color);\n  background: color-mix(in srgb, var(--text-color) 8%, transparent);\n}\n\n.asd__body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  padding: 16px 18px 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.asd__section {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.asd__label {\n  margin: 0;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: var(--text-secondary, #9ca3af);\n}\n\n.asd__field-shell {\n  padding: 12px;\n  border-radius: 16px;\n  background: color-mix(in srgb, var(--text-color) 4%, var(--surface-color));\n  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.22));\n}\n\n.asd__calendar {\n  display: flex;\n  justify-content: center;\n  overflow: hidden;\n  border-radius: 12px;\n}\n\n.asd__calendar .rdrCalendarWrapper,\n.asd__calendar .rdrDateDisplayWrapper,\n.asd__calendar .rdrMonth {\n  background: transparent !important;\n  color: var(--text-color) !important;\n}\n\n.asd__calendar .rdrMonthAndYearPickers select,\n.asd__calendar .rdrWeekDay,\n.asd__calendar .rdrDayNumber span {\n  color: var(--text-color) !important;\n}\n\n.asd__calendar .rdrDayPassive .rdrDayNumber span {\n  color: var(--text-secondary) !important;\n  opacity: 0.55;\n}\n\n.asd__calendar .rdrDayDisabled {\n  background-color: transparent !important;\n}\n\n.asd__calendar .rdrDayToday .rdrDayNumber span:after {\n  background: var(--brand-primary, #0877bc) !important;\n}\n\n.asd__calendar .rdrSelected,\n.asd__calendar .rdrDayStartPreview,\n.asd__calendar .rdrDayEndPreview,\n.asd__calendar .rdrDayInPreview {\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent) !important;\n}\n\n.asd__calendar .rdrNextPrevButton {\n  background: color-mix(in srgb, var(--text-color) 8%, var(--surface-color)) !important;\n}\n\n.asd__calendar .rdrNextPrevButton i,\n.asd__calendar .rdrPprevButton i {\n  border-color: var(--text-color) !important;\n}\n\n.asd__input,\n.asd__select {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 12px 14px;\n  border-radius: 12px;\n  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.28));\n  background: var(--surface-color);\n  color: var(--text-color);\n  color-scheme: light;\n  font: inherit;\n  font-size: 0.95rem;\n  font-weight: 600;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\nhtml[data-theme=\"dark\"] .asd-dialog.MuiPaper-root,\nhtml.dark-mode .asd-dialog.MuiPaper-root,\n.dark-mode .asd-dialog.MuiPaper-root,\nhtml[data-theme=\"dark\"] .asd-modal-box,\nhtml.dark-mode .asd-modal-box,\n.dark-mode .asd-modal-box,\nhtml[data-theme=\"dark\"] .asd__input,\nhtml.dark-mode .asd__input,\n.dark-mode .asd__input,\nhtml[data-theme=\"dark\"] .asd__select,\nhtml.dark-mode .asd__select,\n.dark-mode .asd__select {\n  color-scheme: dark;\n}\n\n.asd__label-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.asd__label-row .asd__label {\n  margin: 0;\n}\n\n.asd__chip--now {\n  padding: 4px 10px;\n  font-size: 0.72rem;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.asd__time-controls {\n  display: flex;\n  align-items: stretch;\n  gap: 8px;\n}\n\n.asd__time-controls .asd__input {\n  flex: 1;\n  min-width: 0;\n}\n\n.asd__input--time::-webkit-calendar-picker-indicator {\n  opacity: 0;\n  width: 0;\n  padding: 0;\n  margin: 0;\n  pointer-events: none;\n}\n\n.asd__clock-btn {\n  appearance: none;\n  flex-shrink: 0;\n  width: 46px;\n  border-radius: 12px;\n  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.28));\n  background: var(--surface-color);\n  color: var(--text-color);\n  display: grid;\n  place-items: center;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n  transition: border-color 0.2s ease, color 0.2s ease, background 0.2s ease;\n}\n\n.asd__clock-btn:hover,\n.asd__clock-btn:focus-visible {\n  outline: none;\n  color: var(--brand-primary, #0877bc);\n  border-color: var(--brand-primary, #0877bc);\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 10%, var(--surface-color));\n}\n\n.asd__input:focus,\n.asd__select:focus {\n  outline: none;\n  border-color: var(--brand-primary, #0877bc);\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent);\n}\n\n.asd__row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n@media (max-width: 420px) {\n  .asd__row {\n    grid-template-columns: 1fr;\n  }\n}\n\n.asd__duration-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.asd__chip {\n  appearance: none;\n  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.28));\n  background: var(--surface-color);\n  color: var(--text-color);\n  border-radius: 999px;\n  padding: 8px 14px;\n  font: inherit;\n  font-size: 0.82rem;\n  font-weight: 650;\n  cursor: pointer;\n  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease,\n    transform 0.2s cubic-bezier(0.25, 1, 0.5, 1);\n}\n\n.asd__chip:hover {\n  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 45%, var(--border-color));\n  transform: translateY(-1px);\n}\n\n.asd__chip.is-active {\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 16%, var(--surface-color));\n  border-color: var(--brand-primary, #0877bc);\n  color: var(--brand-primary, #0877bc);\n}\n\n.asd__day-grid {\n  display: grid;\n  grid-template-columns: repeat(7, minmax(0, 1fr));\n  gap: 6px;\n}\n\n.asd__day {\n  appearance: none;\n  aspect-ratio: 1;\n  min-height: 40px;\n  border-radius: 12px;\n  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.28));\n  background: var(--surface-color);\n  color: var(--text-secondary, #9ca3af);\n  font: inherit;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease,\n    transform 0.2s cubic-bezier(0.25, 1, 0.5, 1);\n}\n\n.asd__day:hover {\n  transform: translateY(-1px);\n  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 45%, var(--border-color));\n}\n\n.asd__day.is-active {\n  background: var(--brand-primary, #0877bc);\n  border-color: var(--brand-primary, #0877bc);\n  color: #fff;\n  box-shadow: 0 6px 16px color-mix(in srgb, var(--brand-primary, #0877bc) 35%, transparent);\n}\n\n.asd__type-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.asd__type-card {\n  appearance: none;\n  width: 100%;\n  text-align: left;\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  padding: 14px 16px;\n  border-radius: 16px;\n  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.28));\n  background: color-mix(in srgb, var(--text-color) 3%, var(--surface-color));\n  color: var(--text-color);\n  cursor: pointer;\n  transition: border-color 0.2s ease, background 0.2s ease, transform 0.2s cubic-bezier(0.25, 1, 0.5, 1),\n    box-shadow 0.2s ease;\n}\n\n.asd__type-card:hover:not(:disabled) {\n  transform: translateY(-2px);\n  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 45%, var(--border-color));\n  box-shadow: 0 10px 24px color-mix(in srgb, var(--brand-primary, #0877bc) 14%, transparent);\n}\n\n.asd__type-card:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.asd__type-card.is-active {\n  border-color: var(--brand-primary, #0877bc);\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 12%, var(--surface-color));\n  box-shadow: 0 0 0 1px color-mix(in srgb, var(--brand-primary, #0877bc) 35%, transparent);\n}\n\n.asd__type-icon {\n  width: 42px;\n  height: 42px;\n  border-radius: 12px;\n  display: grid;\n  place-items: center;\n  flex-shrink: 0;\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 16%, transparent);\n  color: var(--brand-primary, #0877bc);\n}\n\n.asd__type-card.is-active .asd__type-icon {\n  background: var(--brand-primary, #0877bc);\n  color: #fff;\n}\n\n.asd__type-copy {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.asd__type-title {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n}\n\n.asd__type-desc {\n  margin: 0;\n  font-size: 0.84rem;\n  line-height: 1.4;\n  color: var(--text-secondary, #9ca3af);\n}\n\n.asd__type-chevron {\n  align-self: center;\n  color: var(--text-secondary, #9ca3af);\n  opacity: 0.7;\n  flex-shrink: 0;\n}\n\n.asd__alert {\n  margin: 0;\n  padding: 12px 14px;\n  border-radius: 12px;\n  border: 1px solid color-mix(in srgb, #d97706 35%, transparent);\n  background: color-mix(in srgb, #d97706 12%, var(--surface-color));\n  color: #b45309;\n  font-size: 0.88rem;\n  line-height: 1.4;\n}\n\n.dark-mode .asd__alert,\nhtml.dark-mode .asd__alert {\n  color: #fbbf24;\n}\n\n.asd__actions {\n  flex-shrink: 0;\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  padding: 12px 18px max(16px, calc(12px + env(safe-area-inset-bottom, 0px)));\n  border-top: 1px solid var(--border-color, rgba(148, 163, 184, 0.18));\n  background: inherit;\n}\n\n.asd__btn {\n  appearance: none;\n  font: inherit;\n  border: 0;\n  border-radius: 12px;\n  padding: 11px 16px;\n  cursor: pointer;\n  font-weight: 650;\n  transition: transform 0.2s cubic-bezier(0.25, 1, 0.5, 1), filter 0.2s ease,\n    background 0.2s ease;\n}\n\n.asd__btn:not(:disabled):hover {\n  transform: scale(1.01);\n}\n\n.asd__btn:not(:disabled):active {\n  transform: scale(0.98);\n}\n\n.asd__btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.asd__btn--ghost {\n  background: transparent;\n  color: var(--text-secondary, #9ca3af);\n  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.28));\n}\n\n.asd__btn--ghost:hover:not(:disabled) {\n  color: var(--text-color);\n  background: color-mix(in srgb, var(--text-color) 6%, transparent);\n}\n\n.asd__btn--primary {\n  background: var(--brand-primary, #0877bc);\n  color: #fff;\n  box-shadow: 0 8px 20px color-mix(in srgb, var(--brand-primary, #0877bc) 32%, transparent);\n}\n\n.asd__btn--primary:hover:not(:disabled) {\n  filter: brightness(1.06);\n}\n\n.asd__btn--block {\n  width: 100%;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .asd__chip,\n  .asd__day,\n  .asd__type-card,\n  .asd__btn {\n    transition: none;\n  }\n\n  .asd__chip:hover,\n  .asd__day:hover,\n  .asd__type-card:hover:not(:disabled),\n  .asd__btn:not(:disabled):hover,\n  .asd__btn:not(:disabled):active {\n    transform: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
